<template lang="pug">
  div
    div(class="container py-5")
      div(v-html="content")
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CustomApply',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      WebSystems: state => state.model.WebSystems
    }),
    content() {
      return this.WebSystems.data && this.WebSystems.data[0]
        ? this.WebSystems.data[0].web_app_download_text
        : ''
    }
  },
  methods: {
    ...mapActions(['getListModel'])
  },
  created() {
    this.getListModel({
      name: 'WebSystems'
    })
  }
}
</script>
